<script lang="ts" setup>
import type { Statement } from '@/types/domain'
import { computed, inject } from 'vue'
import { DomainTransKey } from '@/i18n/domainTrans'
import { ModuleLocaleKey } from '@/i18n/moduleLocaleContext'
import { ColorScaleKey } from '@/ui/colorScaleContext'

const dt = inject(DomainTransKey)!
const moduleLocale = inject(ModuleLocaleKey, { baseLocale: computed(() => 'no') })

const props = defineProps<{
  statement: Statement
}>()

const colorCtx = inject(ColorScaleKey)!
const $color = computed(() => colorCtx.scale.value.at(props.statement.evaluation))
const emit = defineEmits(['evaluate'])

</script>

<template>
  <div class="menu-item">
    <button
      class="statement"
      :style="{ 'border-left-color': $color }"
      @click="emit('evaluate', statement.id)"
    >
      {{ dt.t(statement.title, statement.title_i18n, moduleLocale.baseLocale.value) }}
    </button>
    <span style="display:none">
      {{ dt.locale() }} / {{ moduleLocale.baseLocale.value }} / {{ JSON.stringify(statement.title_i18n) }}
    </span>
  </div>
</template>

<style scoped>
.historic-statement-left {
  padding: 8px 0px 8px 20px;
  display: box;
  border-radius: 8px 0 0 8px;
}

.historic-statement-right {
  padding: 8px 20px 8px 0;
  display: box;
  border-radius: 0 8px 8px 0;
}

.historic-statement-wrapper {
  display: flex;
  flex-direction: row;
  padding-bottom: 8px;
  width: 100%;
}

.historic-statement {
  background-color: white;
  color: #333;
  padding: 8px 8px;
  text-align: center;
  width: 100%;
}

button.statement {
  border: solid;
  border-width: 0 0 0 24px;
  border-radius: 8px;
}
</style>
